import axios from 'axios';

const LookupService = {


async getDivisions() {
    try {
        const response = await axios.get("/UserDetails/GetDivision");
        return response.data;
    } catch (error) {
        console.error("Error Fetching Divisions", error);
        throw error;
    }
},


async postDivision(payload) {
    try {
        const response = await axios.post("/UserRegister/PostDivision", payload);
        return response.data;
    } catch (error) {
        console.error("Error Inserting Division", error);
        throw error;
    }
},


async getDesignations() {
    try {
        const response = await axios.get("/UserDetails/GetDesignation");
        return response.data;
    } catch (error) {
        console.error("Error Fetching Designations", error);
        throw error;
    }
},


async postDesignation(payload) {
    try {
        const response = await axios.post("/UserRegister/PostDesignation", payload);
        return response.data;
    } catch (error) {
        console.error("Error Inserting Designation", error);
        throw error;
    }
},



async getLocations() {
    try {
        const response = await axios.get("/UserDetails/Locations");
        return response.data;
    } catch (error) {
        console.error("Error Fetching Locations", error);
        throw error;
    }
},
async postLocation(payload) {
    try {
        const response = await axios.post("/UserRegister/PostLocation", payload);
        return response.data;
    } catch (error) {
        console.error("Error Inserting Location", error);
        throw error;
    }
},

async getEmployeeCategories() {
    try {
        const response = await axios.get("/EmployeeCategory/GetEmployeeCategories");
        console.log("[EmployeeCategory] getAll response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error Fetching Employee Categories", error);
        throw error;
    }
},

async addEmployeeCategory({ code, name, createdBy, status, remarks }) {
    try {
        const q = encodeURIComponent;
        const response = await axios.post(
            `/EmployeeCategory/AddEmployeeCategory?p_categoryCode=${q(code)}&p_categoryName=${q(name)}&p_createdBy=${q(createdBy)}&p_isActive=${status === "A"}&p_remarks=${q(remarks)}`
        );
        console.log("[EmployeeCategory] add response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error Adding Employee Category", error);
        throw error;
    }
},

async updateEmployeeCategory({ id, code, name, createdBy, status, remarks }) {
    try {
        const q = encodeURIComponent;
        const response = await axios.post(
            `/EmployeeCategory/UpdateEmployeeCategory?p_categoryCode=${q(code)}&p_categoryName=${q(name)}&p_createdBy=${q(createdBy)}&p_isActive=${status === "A"}&p_remarks=${q(remarks)}&p_categoryId=${q(id)}`                                                                                                                                                                                                                                                                                
        );
        console.log("[EmployeeCategory] update response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error Updating Employee Category", error);
        throw error;
    }
},
};

export default LookupService;